import { Button } from "antd";
import { useState } from "react";
import DownloadIcon from "../../assets/icons/DownloadIcon";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

export default function ExistEmailModal({
  handleClose,
  data,
  ...rest
}: ModalComponentProps<string[]>) {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = () => {
    if (!data?.length) return;
    setIsLoading(true);

    const emailText = data.join(", ");
    const blob = new Blob([emailText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    // Simulate a 500ms loading delay
    setTimeout(() => {
      const a = document.createElement("a");
      a.href = url;
      a.download = "invite-existing-emails.txt";
      a.click();

      URL.revokeObjectURL(url);
      setIsLoading(false);
    }, 500);
  };

  return (
    <CustomModal
      title="Email already exists"
      {...rest}
      handleClose={handleClose}
      width={400}
      footer={null}
      maskClosable={false}
    >
      <div className="flex justify-center">
        <Button
          onClick={handleDownload}
          className="download-button"
          icon={<DownloadIcon />}
          loading={isLoading}
        >
          Download existing emails
        </Button>
      </div>
    </CustomModal>
  );
}
